const debtorsCount = [
  { value: 1, label: '1 Kreditnehmer' },
  { value: 2, label: '2 Kreditnehmer' }
]
export default debtorsCount
